<div class="loading-page">
    <rds-progress-spinner white></rds-progress-spinner>
</div>